import { Loader } from '@unistocks/components/loading/spinner/loader';
import { Header } from '@unistocks/features/navigation/header';
import { NavSidebar } from '@unistocks/features/navigation/sidebar';
import { Navigator, Slot } from 'expo-router';
import React from 'react';

export default function AdminLayout() {
  return (
    <Navigator>
      <Header />
      <NavSidebar />
      <React.Suspense fallback={<Loader />}>
        <Slot />
      </React.Suspense>
    </Navigator>
  );
}
